/*!
VueLayers
Web map Vue components with the power of OpenLayers

@package vuelayers
@author Vladimir Vershinin <ghettovoice@gmail.com>
@version 0.10.25
@license MIT
@copyright (c) 2017-2018, Vladimir Vershinin <ghettovoice@gmail.com>
*/
'use strict';

var minilo = require('../util/minilo');

var withUrl = {
  props: {
    url: {
      type: String
    }
  },
  computed: {
    /**
     * @type {string}
     */
    urlTmpl: function urlTmpl() {
      return minilo.replaceTokens(this.url, minilo.pick(this, this.urlTokens));
    },

    /**
     * @type {string[]}
     */
    urlTokens: function urlTokens() {
      return [];
    }
  }
};

module.exports = withUrl;



//////////////////
// WEBPACK FOOTER
// ./~/vuelayers/lib/mixin/with-url.js
// module id = 240
// module chunks = 1